var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 6.75,
    width: 18,
    height: 13.5,
    rx: 2,
    stroke: "#657B90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.125L12.6056 14.1778C13.1686 14.4593 13.8314 14.4593 14.3944 14.1778L22.5 10.125",
    stroke: "#657B90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageLight);
export default __webpack_public_path__ + "static/media/Message_light.29356daeed6e523d9efc5a1193d4c348.svg";
export { ForwardRef as ReactComponent };